import React, { useState } from "react";
import "../../styles/components/CasesHero.css";

import resultsBg from "../../img/hero/cases-hero.webp";
import btnArrow from "../../img/hero/arrow-herro.png";

import Modal from "../../components/Modal";            // ✅ модалка
import ContactFormSimple from "../../components/ContactFormSimple"; // ✅ форма

export default function CasesHero() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section
      className="contacts-results contacts-results-anim"
      aria-label="Contacts Results hero"
    >
      {/* Правий образ */}
      <img
        className="contacts-results__bg contacts-results-anim__art"
        src={resultsBg}
        alt=""
        aria-hidden="true"
      />

      {/* Скляна плашка з заголовком */}
      <div className="contacts-results__title contacts-results-anim__title">
        <h1 className="contacts-results__h1">
          <span className="contacts-results__h1-strong">Real Results:</span>
          <br />
          <span className="contacts-results__h1-normal">
            Our AI-Driven Projects in Action
          </span>
        </h1>
      </div>

      {/* Низ: опис + глобальна кнопка */}
      <div className="contacts-results__bottom contacts-results-anim__bottom">
        <p className="contacts-results__lead">
          Explore some of our successful implementations and the impact they’ve made.
        </p>

        <button
          type="button"
          className="Secondary v2"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Start Your Project</span>
          {btnArrow ? (
            <img
              className="Secondary__circle"
              src={btnArrow}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <span className="Secondary__circle">➜</span>
          )}
        </button>
      </div>

      {/* Модалка */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
